import api from './api';
import { GenerateReportRequest } from '../types';

class ReportsService {
  async generateReport(request: GenerateReportRequest): Promise<Blob> {
    const response = await api.post('/reports/generate', request, {
      responseType: 'blob'
    });
    return response.data;
  }

  async downloadReport(request: GenerateReportRequest): Promise<void> {
    try {
      const blob = await this.generateReport(request);
      
      // Crear URL del blob y descargar
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      
      // Generar nombre del archivo
      const extension = request.formato === 'excel' ? 'xlsx' : 'pdf';
      const fecha = new Date().toISOString().split('T')[0];
      const filename = `reporte_${request.tipo}_${fecha}.${extension}`;
      
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      
      // Limpiar
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
      
    } catch (error) {
      console.error('Error downloading report:', error);
      throw new Error('Error al descargar el reporte');
    }
  }
}

const reportsService = new ReportsService();
export default reportsService;